import React from 'react'
import Header from '../../Component/Header'
import Footer from '../../Component/Footer'
import Programme from '../Programme'

export default function LayoutProgramme() {
    return (
        <>
            <Header />
            <Programme />
            <Footer />
        </>
    )
}
